/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateDomainRequestDto,
  CreateOrganizationDomainParams,
  DeleteOrganizationDomainParams,
  DisableOrganizationDomainParams,
  DomainPairDto,
  ListOrganizationDomainsParams,
  VerifyOrganizationDomainParams
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListOrganizationDomainsUrl = (params: ListOrganizationDomainsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/domains?${stringifiedParams}` : `/domains`
}

export const listOrganizationDomains = async (params: ListOrganizationDomainsParams, options?: Parameters<typeof customFetch>[1]): Promise<DomainPairDto[]> => {

  return customFetch<DomainPairDto[]>(getListOrganizationDomainsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrganizationDomainsQueryKey = (params?: ListOrganizationDomainsParams,) => {
    return [
    `/domains`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrganizationDomainsQueryOptions = <TData = Awaited<ReturnType<typeof listOrganizationDomains>>, TError = unknown>(params: ListOrganizationDomainsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationDomains>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrganizationDomainsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrganizationDomains>>> = ({ signal }) => listOrganizationDomains(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrganizationDomains>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrganizationDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof listOrganizationDomains>>>
export type ListOrganizationDomainsQueryError = unknown


export function useListOrganizationDomains<TData = Awaited<ReturnType<typeof listOrganizationDomains>>, TError = unknown>(
 params: ListOrganizationDomainsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationDomains>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationDomains>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationDomains<TData = Awaited<ReturnType<typeof listOrganizationDomains>>, TError = unknown>(
 params: ListOrganizationDomainsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationDomains>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizationDomains>>,
          TError,
          Awaited<ReturnType<typeof listOrganizationDomains>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrganizationDomains<TData = Awaited<ReturnType<typeof listOrganizationDomains>>, TError = unknown>(
 params: ListOrganizationDomainsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationDomains>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListOrganizationDomains<TData = Awaited<ReturnType<typeof listOrganizationDomains>>, TError = unknown>(
 params: ListOrganizationDomainsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrganizationDomains>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrganizationDomainsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateOrganizationDomainUrl = (params: CreateOrganizationDomainParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/domains?${stringifiedParams}` : `/domains`
}

export const createOrganizationDomain = async (createDomainRequestDto: CreateDomainRequestDto,
    params: CreateOrganizationDomainParams, options?: Parameters<typeof customFetch>[1]): Promise<DomainPairDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<DomainPairDto>(getCreateOrganizationDomainUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createDomainRequestDto)
  }
);}





export const getCreateOrganizationDomainMutationKey = () => ['createOrganizationDomain'] as const;

export const getCreateOrganizationDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationDomain>>, TError,CreateOrganizationDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrganizationDomain>>, TError,CreateOrganizationDomainMutationVariables, TContext> => {

const mutationKey = getCreateOrganizationDomainMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrganizationDomain>>, CreateOrganizationDomainMutationVariables> = (props) => {
          const {data,params} = props ?? {};

          return  createOrganizationDomain(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganizationDomainMutationResult = NonNullable<Awaited<ReturnType<typeof createOrganizationDomain>>>
    export type CreateOrganizationDomainMutationBody = CreateDomainRequestDto
    export type CreateOrganizationDomainMutationError = unknown
    export type CreateOrganizationDomainMutationVariables = {data: CreateDomainRequestDto;params: CreateOrganizationDomainParams}

    export const useCreateOrganizationDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrganizationDomain>>, TError,CreateOrganizationDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrganizationDomain>>,
        TError,
        CreateOrganizationDomainMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOrganizationDomainMutationOptions(options), queryClient);
    }
    export const getVerifyOrganizationDomainUrl = (id: string,
    params: VerifyOrganizationDomainParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/domains/${id}/verify?${stringifiedParams}` : `/domains/${id}/verify`
}

export const verifyOrganizationDomain = async (id: string,
    params: VerifyOrganizationDomainParams, options?: Parameters<typeof customFetch>[1]): Promise<DomainPairDto> => {

  return customFetch<DomainPairDto>(getVerifyOrganizationDomainUrl(id,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getVerifyOrganizationDomainMutationKey = () => ['verifyOrganizationDomain'] as const;

export const getVerifyOrganizationDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyOrganizationDomain>>, TError,VerifyOrganizationDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyOrganizationDomain>>, TError,VerifyOrganizationDomainMutationVariables, TContext> => {

const mutationKey = getVerifyOrganizationDomainMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyOrganizationDomain>>, VerifyOrganizationDomainMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  verifyOrganizationDomain(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyOrganizationDomainMutationResult = NonNullable<Awaited<ReturnType<typeof verifyOrganizationDomain>>>

    export type VerifyOrganizationDomainMutationError = unknown
    export type VerifyOrganizationDomainMutationVariables = {id: string;params: VerifyOrganizationDomainParams}

    export const useVerifyOrganizationDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyOrganizationDomain>>, TError,VerifyOrganizationDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyOrganizationDomain>>,
        TError,
        VerifyOrganizationDomainMutationVariables,
        TContext
      > => {
      return useMutation(getVerifyOrganizationDomainMutationOptions(options), queryClient);
    }
    export const getDisableOrganizationDomainUrl = (id: string,
    params: DisableOrganizationDomainParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/domains/${id}/disable?${stringifiedParams}` : `/domains/${id}/disable`
}

export const disableOrganizationDomain = async (id: string,
    params: DisableOrganizationDomainParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDisableOrganizationDomainUrl(id,params),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDisableOrganizationDomainMutationKey = () => ['disableOrganizationDomain'] as const;

export const getDisableOrganizationDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableOrganizationDomain>>, TError,DisableOrganizationDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof disableOrganizationDomain>>, TError,DisableOrganizationDomainMutationVariables, TContext> => {

const mutationKey = getDisableOrganizationDomainMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableOrganizationDomain>>, DisableOrganizationDomainMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  disableOrganizationDomain(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisableOrganizationDomainMutationResult = NonNullable<Awaited<ReturnType<typeof disableOrganizationDomain>>>

    export type DisableOrganizationDomainMutationError = unknown
    export type DisableOrganizationDomainMutationVariables = {id: string;params: DisableOrganizationDomainParams}

    export const useDisableOrganizationDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableOrganizationDomain>>, TError,DisableOrganizationDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableOrganizationDomain>>,
        TError,
        DisableOrganizationDomainMutationVariables,
        TContext
      > => {
      return useMutation(getDisableOrganizationDomainMutationOptions(options), queryClient);
    }
    export const getDeleteOrganizationDomainUrl = (id: string,
    params: DeleteOrganizationDomainParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/domains/${id}?${stringifiedParams}` : `/domains/${id}`
}

export const deleteOrganizationDomain = async (id: string,
    params: DeleteOrganizationDomainParams, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

  return customFetch<void>(getDeleteOrganizationDomainUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteOrganizationDomainMutationKey = () => ['deleteOrganizationDomain'] as const;

export const getDeleteOrganizationDomainMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationDomain>>, TError,DeleteOrganizationDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationDomain>>, TError,DeleteOrganizationDomainMutationVariables, TContext> => {

const mutationKey = getDeleteOrganizationDomainMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganizationDomain>>, DeleteOrganizationDomainMutationVariables> = (props) => {
          const {id,params} = props ?? {};

          return  deleteOrganizationDomain(id,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationDomainMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganizationDomain>>>

    export type DeleteOrganizationDomainMutationError = unknown
    export type DeleteOrganizationDomainMutationVariables = {id: string;params: DeleteOrganizationDomainParams}

    export const useDeleteOrganizationDomain = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationDomain>>, TError,DeleteOrganizationDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrganizationDomain>>,
        TError,
        DeleteOrganizationDomainMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOrganizationDomainMutationOptions(options), queryClient);
    }
